import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import Request from '../util/fetch';

export const PAGESIZE = 10;
export const WelcomeType = 'welcome';

makeActionType(WelcomeType, ['fetchManPlanInfoSuccess', 'fetchNormalManPlanInfoSuccess', 'listInit', 'listDone', 'resetTasksData', 'resettaskdetail', 'getCollectionTaskDetailSuccess', 'hasMoney','subDone', 'subInit', 'getmsg','msgfail','savepage','makeread', 'makeallread','getgeneralinfodata','getmoneyearns','getCollectionAllTaskListSuccess', 'getCollectionTaskParticipateListSuccess']);

import { Toast } from '../component/message';
export const getMsg = makeActionCreator(getActionType(WelcomeType, 'getmsg'));
export const fail = makeActionCreator(getActionType(WelcomeType, 'msgfail'));
export const savePage = makeActionCreator(getActionType(WelcomeType, 'savepage'));
export const makeRead = makeActionCreator(getActionType(WelcomeType, 'makeread'));
export const makeAllRead = makeActionCreator(getActionType(WelcomeType, 'makeallread'));
export const getGenetalInfo = makeActionCreator(getActionType(WelcomeType, 'getgeneralinfodata'));
export const getMoneyearns = makeActionCreator(getActionType(WelcomeType, 'getmoneyearns'));
export const hasMoney = makeActionCreator(getActionType(WelcomeType, 'hasMoney'));
export const getCollectionAllTaskListSuccess = makeActionCreator(getActionType(WelcomeType, 'getCollectionAllTaskListSuccess'));
export const getCollectionTaskParticipateListSuccess = makeActionCreator(getActionType(WelcomeType, 'getCollectionTaskParticipateListSuccess'));
export const getCollectionTaskDetailSuccess = makeActionCreator(getActionType(WelcomeType, 'getCollectionTaskDetailSuccess'));
export const fetchManPlanInfoSuccess = makeActionCreator(getActionType(WelcomeType, 'fetchManPlanInfoSuccess'));
export const fetchNormalManPlanInfoSuccess = makeActionCreator(getActionType(WelcomeType, 'fetchNormalManPlanInfoSuccess'));


// 表单操作 失败操作集
const OPRATE_FAIL = (dispatch, error) => {
  let rerr = Request.resolveError(error);
  Toast({
      type: 'error',
      text: rerr.msg
  });
  // dispatch(editSaveComplete({}))
}

/**
 * 获取消息列表
 * @param {} data
 */
export const getMsgData = (data) => (dispatch) => {
    let page = data.page;
    dispatch({
      type: getActionType(WelcomeType, 'request'),
      payload: data
    })
    return Request.fetch({
      url: 'api/cloudvideo/message/list',
      data: {
        "limit": PAGESIZE,
        "offset": (page - 1) * PAGESIZE
      }
    })
      .then((result) => {
        let resdata = result.data;
        resdata.page = page;
        dispatch(getMsg(resdata));
      })
      .catch((err) => {
        let rerr = Request.resolveError(err);
        dispatch(fail(rerr));
      })
}
/**
 * 消息已读
 * @param {} data
 */
export const hasRead = (data) => (dispatch) => {
  let id = data.id;
  let page = data.page;
  let index = data.index;
  dispatch({
    type: getActionType(WelcomeType, 'request'),
    payload: data
  })
  return Request.fetch({
    url: 'api/cloudvideo/message/read',
    data: {
      "id": data.id
    }
  })
    .then((result) => {
      let resdata = result;
      resdata.id = id;
      resdata.page = page;
      resdata.index = index;
      dispatch(makeRead(resdata));
    })
    .catch((err) => {
      let rerr = Request.resolveError(err);
      dispatch(fail(rerr));
    })
}
export const makeMsgAllRead = (data) => (dispatch) => {
  return Request.fetch({
    url: 'api/cloudvideo/message/markread',
    method: 'GET',
    data: {
      fromPage: 2
    }
  })
    .then(() => {
      dispatch(makeAllRead(data));
    })
    .catch((err) => {
      let rerr = Request.resolveError(err);
      dispatch(fail(rerr));
    })
}
/**
 * 获取现金收益数据
 * @param {} data
 */
export const getMoneyearnsData = () => (dispatch) => {
  dispatch({
    type: getActionType(WelcomeType, 'request'),
  })
  return Request.fetch({
    url: 'api/cloudvideo/activity/moneyplan/earns',
  })
    .then((result) => {
      let resdata = result.data;
      dispatch(getMoneyearns(resdata));
    })
    .catch((err) => {
      let rerr = Request.resolveError(err);
      dispatch(fail(rerr));
    })
}
/**
 * 获取数据中心
 * @param {} data
 */
export const getGeneralInfoData = () => (dispatch) => {
  dispatch({
    type: getActionType(WelcomeType, 'request'),
  })
  return Request.fetch({
    url: 'api/cloudvideo/data/statistic/get',
  })
    .then((result) => {
      let resdata = result.data;
      dispatch(getGenetalInfo(resdata));
    })
    .catch((err) => {
      let rerr = Request.resolveError(err);
      dispatch(fail(rerr));
    })
}
/**
 * 判断是否参加了现金计划
 * @param {} data
 * 现金激励参与状态 现在移到redux store的User上
 */
// export const hasMoneyExcite = (data) => (dispatch) => {
//   dispatch({
//     type: getActionType(WelcomeType, 'request'),
//     payload: data
//   })
//   return Request.fetch({
//     url: 'api/cloudvideo/activity/moneyexcite/userstate',
//   })
//     .then((result) => {
//       let resdata = result.data.participateState;
//       dispatch(hasMoney(resdata));
//     })
//     .catch((err) => {
//       let rerr = Request.resolveError(err);
//       dispatch(fail(rerr));
//     })
// }
/**
 * 获取有奖征稿所有列表
 * @param {} data
 */
export const getCollectionAllTaskList = (data) => (dispatch) => {
  OPRATE_INIT(dispatch, 'listInit');
  return Request.fetch({
    url: 'api/cloudvideo/collection/task/list',
    data: {
      "limit": data.limit,
      "offset": data.offset
    }
  }).then((result) => {
    let resdata = result.data;
    resdata.page = parseInt(data.offset / data.limit) + 1;
    dispatch(getCollectionAllTaskListSuccess(resdata));
    OPRATE_INIT(dispatch, 'listDone');
    return resdata;
  }).catch(error => {
    OPRATE_FAIL(dispatch, error);
  });
}

/**
 * 获取有奖征稿我的参与列表
 * @param {} data
 */
export const getCollectionParticipateTaskList = (data) => (dispatch) => {
  OPRATE_INIT(dispatch, 'listInit');
  return Request.fetch({
    url: 'api/cloudvideo/collection/participate/list',
    data: {
      "limit": data.limit,
      "offset": data.offset
    }
  }).then((result) => {
    let resdata = result.data;
    resdata.page = parseInt(data.offset / data.limit) + 1;
    dispatch(getCollectionTaskParticipateListSuccess(resdata));
    OPRATE_INIT(dispatch, 'listDone');
    return resdata;
  }).catch(error => {
    OPRATE_FAIL(dispatch, error);
  });
}
/**
 * 视频征稿任务详情页
 * @param {} data
 */
export const getCollectionTaskDetail = (data) => (dispatch) => {
  dispatch({
    type: getActionType(WelcomeType, 'resettaskdetail')
  });
  return Request.fetch({
    url: 'api/cloudvideo/collection/task/detail',
    data: {
      "taskId": data.taskId,
    }
  }).then((result) => {
    let resdata = result.data;
    dispatch(getCollectionTaskDetailSuccess(resdata));
    return resdata;
  }).catch(error => {
    OPRATE_FAIL(dispatch, error);
  });
}
// 收藏操作 init
const OPRATE_INIT = (dispatch, name) => {
  dispatch({
      type: getActionType(WelcomeType, name)
  });
}
/**
 * 收藏该投稿任务
 * @param {} data
 */
export const subCollectionTask = (data) => (dispatch) => {
  OPRATE_INIT(dispatch, 'subInit');
  return Request.fetch({
    url: 'api/cloudvideo/collection/task/sub',
    data: {
      "taskId": data.taskId,
    }
  }).then((result) => {
    let resdata = result;
    OPRATE_INIT(dispatch, 'subDone');
    return true;
  })
  .catch(error => {
    OPRATE_FAIL(dispatch, error);
  });
}
/**
 * 取消收藏该投稿任务
 * @param {} data
 */
export const unSubCollectionTask = (data) => (dispatch) => {
  OPRATE_INIT(dispatch, 'subInit');
  return Request.fetch({
    url: 'api/cloudvideo/collection/task/unsub',
    data: {
      "taskId": data.taskId,
    }
  }).then((result) => {
    let resdata = result;
    OPRATE_INIT(dispatch, 'subDone');
    return true;
  })
  .catch(error => {
    OPRATE_FAIL(dispatch, error);
  });
}
/**
 * 重置列表任务
 * @param {} data
 */
export const resetTaskData = (data) => (dispatch) => {
  return new Promise((resolve) => {
    resolve(dispatch({
      type: getActionType(WelcomeType, 'resetTasksData'),
      payload: data
    }));
  })

}

/**
 * 获取达人计划信息
 * @param {} data
 */
export const fetchManPlanInfo = (data) => (dispatch) => {
  return Request.fetch({
    url: 'api/cloudvideo/talent/detail'
  }).then((result) => {
    let resdata = result.data;
    dispatch(fetchManPlanInfoSuccess(resdata));
  }).catch(error => {

  })

}

/**
 * 获取达人计划信息
 * @param {} data
 */
export const fetchNormalManPlanInfo = (data) => (dispatch) => {
  return Request.fetch({
    url: 'api/cloudvideo/talent/ordinary/detail'
  }).then((result) => {
    let resdata = result.data;
    dispatch(fetchNormalManPlanInfoSuccess(resdata));
  }).catch(error => {

  })
}



// WEBPACK FOOTER //
// ./client/action/welcome.js